<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item, index) in breadcrumb"
                            :key="index"
                            :to="item.to">{{item.label}}
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="产品ID"
                        prop="id">
            <el-input placeholder="请输入产品ID"
                      v-model="search.id"></el-input>
          </el-form-item>
          <el-form-item label="产品名称"
                        prop="name">
            <el-input placeholder="请输入名称"
                      v-model="search.keyword"></el-input>
          </el-form-item>
          <el-form-item label="所属客户"
                        prop="customerid">
            <sj-remote-select v-model="search.customerid"
                              :remote-method="getCustomerTable"
                              :remote-params="{type:20}"
                              style="width: 100%;"></sj-remote-select>
          </el-form-item>
          <el-form-item label="检查类型"
                        prop="prod_type">
            <el-select v-model="search.prod_type"
                       clearable
                       placeholder="请选择"
                       class="width-max">
              <el-option
                v-for="(label, value) in types"
                :key="value"
                :label="label"
                :value="value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-export"
                   @click="onExportPage()"></el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">

        <el-button type="warning"
                   size="small"
                   @click="moveDialogVisible=true"
                   :disabled="!multipleSelectionIds.length">移动分类
        </el-button>

      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                @selection-change="val => this.multipleSelectionIds = val.map(({id}) => id)"
                style="width: 100%">
        <el-table-column
          type="selection"
          width="39">
        </el-table-column>
        <el-table-column prop="id"
                         label="产品ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="name"
                         label="产品名称"
                         min-width="120"></el-table-column>
        <el-table-column prop="customer.name"
                         label="所属客户"
                         min-width="120"></el-table-column>
        <el-table-column prop="admin_user.name"
                         label="所属用户"
                         min-width="120"></el-table-column>
        <el-table-column prop="name"
                         label="检查类型"
                         min-width="120"
                         :formatter="(row) => types[row.prod_type]"></el-table-column>
        <el-table-column prop="created_at"
                         label="添加日期"
                         width="190"></el-table-column>
        <el-table-column prop="updated_at"
                         label="更新日期"
                         width="190"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <clb-product-move-dialog :visible.sync="moveDialogVisible"
                             :ids="multipleSelectionIds"
                             @success="onRefresh"/>
  </div>
</template>

<script>
import { searchRules } from '../clb-product.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'
import ClbProductMoveDialog from '@views/clb-product/components/ClbProductMoveFormDialog'

export default {
  components: {ClbProductMoveDialog},
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        prod_categid: this.$route.query.prod_categid,
        id: null,
        keyword: null,
        prod_type: null,
        customerid: null,
      },
      exportHeader: [
        {
          key: 'id',
          text: '产品ID',
        },
        {
          key: 'name',
          text: '产品名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
      multipleSelectionIds: [],
      moveDialogVisible: false,
      breadcrumb: [],
    }
  },
  computed: Vuex.mapState({
    types: state => state.clbProduct.types,
  }),
  created () {
    this.generateBreadcrumb()
  },
  methods: {
    ...Vuex.mapActions([]),
    ...request.map(['getClbProductAreaTable', 'getClbProductCategoryTable', 'getCustomerTable']),
    async generateBreadcrumb () {
      this.breadcrumb = [
        {
          to: {
            path: '/clb-product-area/table'
          },
          label: '查理宝任务区域列表',
        },
        {
          to: {
            path: '/clb-product-category/table'
          },
          label: '查理宝任务分类列表',
        },
      ]
      if (this.$route.query.prod_categid) {
        let {data: productCategory} = await request.loading('getClbProductCategoryDetail', {id: this.$route.query.prod_categid})
        this.breadcrumb.push({
          label: productCategory.name,
        })
        let {data: productArea} = await request.loading('getClbProductAreaDetail', {id: productCategory.prod_classid})
        this.breadcrumb[1].to.query = {prod_classid: productCategory.prod_classid}
        this.breadcrumb.splice(1, 0, {
          label: productArea.name,
        })
      }
    },
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getClbProductTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportClbProductData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onDelete (index, rows) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deleteClbProductData', {id: rows[index].id}).then(() => {
          this.$message.success('删除成功')
          rows.splice(index, 1)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/clb-product/pages/ClbProductTable.vue